import {
  Ambulance,
  Briefcase,
  Building2,
  Calculator,
  Car,
  Globe,
  HardHat,
  House,
  Landmark,
  ScrollText,
  ShieldCheck,
  Stethoscope,
  Users,
  type LucideIcon,
} from "lucide-react";

/** Decorative tile icon for each practice area, keyed by slug. */
export const practiceIcons: Record<string, LucideIcon> = {
  "personal-injury-lawyer-seo": Ambulance,
  "dui-dwi-lawyer-seo": Car,
  "family-law-lawyer-seo": Users,
  "criminal-defense-lawyer-seo": ShieldCheck,
  "estate-planning-lawyer-seo": ScrollText,
  "immigration-lawyer-seo": Globe,
  "bankruptcy-lawyer-seo": Landmark,
  "employment-law-lawyer-seo": Briefcase,
  "workers-compensation-lawyer-seo": HardHat,
  "tax-law-lawyer-seo": Calculator,
  "medical-malpractice-lawyer-seo": Stethoscope,
  "real-estate-law-lawyer-seo": House,
  "corporate-business-lawyer-seo": Building2,
};
